<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :modal="false"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="500px"
    title="新增职能模块"
  >
    <el-row style="margin-bottom:20px" :gutter="20">
      <el-col :span="4">职能模块名称</el-col>
      <el-col :span="20">
        <el-input v-model="名称" size="mini" placeholder="建议：英文缩写-中文名称 例如：IBD-投行"></el-input>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:20px" :gutter="20">
      <el-col :span="4">行业类别</el-col>
      <el-col :span="20">
        <el-select v-model="类型" size="mini" placeholder="职能模块所属的行业类别，下拉选择">
          <el-option v-for="(item, idx) in types" :key="idx" :value="item"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:20px" :gutter="20">
      <el-col :span="4">细分职能</el-col>
      <el-col :span="20">
        <el-select
          v-model="二级职能"
          size="mini"
          placeholder="输入二级职能,回车添加"
          default-first-option
          filterable
          multiple
          allow-create
        >
          <el-option v-for="(item, idx) in 二级职能" :key="idx" :value="item"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:50px" :gutter="20">
      <el-col :span="4">擅长方向</el-col>
      <el-col :span="20">
        <el-select
          v-model="擅长方向"
          size="mini"
          placeholder="输入擅长方向,回车添加"
          default-first-option
          filterable
          multiple
          allow-create
        >
          <el-option v-for="(item, idx) in 擅长方向" :key="idx" :value="item"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:20px" :gutter="20">
      <el-col :span="4">负责人</el-col>
      <el-col :span="20">
        <el-select v-model="负责人" size="mini" placeholder="选择负责人" filterable>
          <el-option v-for="(item, idx) in accounts" :key="idx" :value="item"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="center">
      <el-button class="mr20" size="mini" @click="cancel">取消</el-button>
      <el-button class="mr20" type="primary" size="mini" @click="save">点击创建</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
const types = [
  '通用-职能',
  '金融-职能',
  '咨询-职能',
  '互联网-职能',
  '消费-职能',
  '零售-职能',
  '新零售-职能',
  '医药器械-职能',
  '医疗大健康-职能',
  '交通贸易-职能',
  '广告-职能',
  '文化传媒-职能',
  '教育-职能',
  '机械制造-职能',
  '房地产-职能',
  '电子通讯-职能',
  '餐饮旅游-职能',
  '服务外包-职能',
  '农林牧渔-职能',
  '能源化工-职能',
  '政府/公共事业/非营利机构-职能',
  '其他-职能',
]
export default {
  data() {
    return {
      dialogVisible: false,
      types,
      名称: '',
      类型: '',
      二级职能: [],
      擅长方向: [],
      负责人: app.user.account,
      accounts: app.accounts,
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    cancel() {
      this.dialogVisible = false
    },
    async save() {
      const res = await app.service('misc').addCategory({
        名称: this.名称,
        类型: this.类型,
        二级职能: this.二级职能,
        擅长方向: this.擅长方向,
        负责人: [this.负责人],
      })
      if (res.status == 'success') {
        this.$message.success(res.msg)
        app.getCats()
      }
      this.$emit('confirmCreate', { 职能模块: this.名称, 擅长方向: this.擅长方向, 细分职能: this.二级职能 })
      this.dialogVisible = false
      this.名称 = ''
      this.类型 = ''
      this.二级职能 = []
      this.擅长方向 = []
    },
  },
}
</script>
